export enum GuestValidity {
  Undefined = 'Undefined',
  OneDay = 'OneDay',
  OneTime = 'OneTime',
  Permanent = 'Permanent',
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  DateRange = 'DateRange',
}

export enum ServerGuestValidity {
  Undefined = 'Undefined',
  OneDay = 'OneDay',
  OneTime = 'OneTime',
  Permanent = 'Permanent',
  DateRange = 'DateRange',
}
